import React from 'react';
import imageUrl from 'assets/images/Sales_Order.png';
import { Typography } from '../../../node_modules/@mui/material/index';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { FABRICUSER, GARMENTUSER } from 'utils/constants';
// import { getBarcodeScanData } from 'Service/ApiService';
// import { showAlert } from 'utils/ErrorMessage';

// const customer = JSON.parse(localStorage.getItem('headerCustomer'));
const SampleRequestDashboard = () => {
  const [isData, setIsData] = React.useState(false);
  const [isClick, setClick] = React.useState(false);
  const [designNumber, setDesignNumber] = React.useState('');
  const [designError, setDesignError] = React.useState('');
  const navigate = useNavigate();
  const handleDivClick = (value) => () => {
    if (value == 'design') {
      setClick(true);
    } else {
      sendNav();
    }
  };
  const handleCloseDialog = () => {
    if (!isData) {
      setClick(false);
      setDesignNumber('');
      setDesignError('');
    }
  };

  const handleOk = () => {
    if (!designNumber.trim()) {
      setDesignError('Design Number is required');
      return;
    }
    setIsData(true);
    // navigate to sample-design page and pass designNumber via state
    navigate('/sample-design', { state: { designNumber: designNumber.trim() } });
    // reset dialog state
    setIsData(false);
    setClick(false);
    setDesignNumber('');
    setDesignError('');
  };
  
  const handleDivKeyPress = (value) => (event) => {
    if (event.key === 'Enter') {
      if (value == 'design') {
        setClick(true);
      } else {
        sendNav();
      }
    }
  };
  const sendNav = () => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const userVerticalId = String(user?.userVerticalId || '');

    if (!userVerticalId) {
      navigate('/login', { replace: true });
      return;
    }

    if (userVerticalId == FABRICUSER) {
      navigate('/sample-request-barcode-scan');
    } else if (userVerticalId.toLowerCase().includes(GARMENTUSER.toLowerCase())) {
      navigate('/sample-request-barcode-scan');
    }
  };
  return (
    <div className="bg" style={{ display: 'block' }}>
      <div className="cutrange">
        <span className="font20">SAMPLE REQUEST DASHBOARD</span>
      </div>

      <div>
        <div style={{ paddingBottom: '20px' }} className="horizontal-center">
          <div className="flexWrapper-d">
            <div
              style={{ width: '150px' }}
              className="card-subtitle"
              onClick={handleDivClick('design')}
              onKeyDown={handleDivKeyPress('design')}
              role="button"
              tabIndex={0}
            >
              <div style={{ padding: '10px' }} className="horizontal-center">
                <div>
                  <div className="horizontal-center">
                    <img src={imageUrl} alt="Design No Entry" style={{ width: 'auto' }} />
                  </div>
                  <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                    Design No Entry
                  </Typography>
                </div>
              </div>
            </div>
            <div
              style={{ width: '150px' }}
              className="card-subtitle"
              onClick={handleDivClick('/sample-request-barcode-scan')}
              onKeyDown={handleDivKeyPress('/sample-request-barcode-scan')}
              role="button"
              tabIndex={0}
            >
              <div style={{ padding: '10px' }} className="horizontal-center">
                <div>
                  <div className="horizontal-center">
                    <img src={imageUrl} alt="Barcode Scan" style={{ width: 'auto' }} />
                  </div>
                  <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                    Barcode Scan
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Design Number Dialog kept in this page */}
      <Dialog open={isClick} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Enter Design Number</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <TextField
              autoFocus
              fullWidth
              label="Design Number"
              variant="outlined"
              value={designNumber}
              onChange={(e) => { setDesignNumber(e.target.value); if (designError) setDesignError(''); }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleOk(); }}
              helperText={designError}
              error={!!designError}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={isData}>Cancel</Button>
          <Button variant="contained" onClick={handleOk} disabled={isData}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SampleRequestDashboard;
